import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, Inject, Input, OnInit, Output, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ObjFilter } from '@app/components/tools/ObjFilter';
import { Customer } from '@app/models/customers/Customer';
import { OffersFilters } from '@app/models/filtermodels/OffersFilters';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { OffersResponse } from '@app/models/offers/OffersResponse';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { AuthService } from '@app/services/auth.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { TrafficsService } from '@app/services/traffics.service';
import { MediaService } from '@app/services/media.service';
@Component({
    selector: 'clever-hotelextrafilter',
    templateUrl: './hotelfilter.component.html',
    styleUrls: ['./hotelfilter.component.scss'],
    standalone: false
})
export class HotelExtrafFilterComponent implements OnInit {
    @Input() mode: string;
    @Input() type: string;
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();
    filtersStaticData: OffersFilters;
    tmp_filtersStaticData: OffersFilters;
    isBrowser = signal<boolean>(false);
    loading = signal<boolean>(true);
    flexfromtraffics: string = '0';
    realparams: ParamFilters;
    tourOperatorList = signal<any>(null);
    partner = signal<Partner>(null);
    destroyRef = inject(DestroyRef);
    tmp_stat: OffersResponse;
    currentCustomer: Customer;

    constructor(
        protected mediaService: MediaService,
        protected trafficsService: TrafficsService,
        protected guardService: AuthGuardService,
        protected authService: AuthService,
        protected hotelService: HotelFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            this.initPartnerSub();
            this.initAuth();
        }
    }

    async initAuth() {
        this.authService.auth$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((customer: Customer) => {
            if (customer?.email?.length > 0) {
                this.currentCustomer = customer;
            }
        });
    }

    initPartnerSub(): void {
        this.guardService.getPartner$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner.set(partner);
                this.initFilters();
            }
        });
    }

    initFilters(): void {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(params => {
            if (params && JSON.stringify(params) !== JSON.stringify(this.realparams)) {
                this.realparams = JSON.parse(JSON.stringify(params));
                if (this.partner().traffics.aktiv) {
                    this.initFilter();
                } else {
                    this.loading.set(false);
                }
            }
        });
    }

    closeextras() {
        this.closeModal.emit(true);
    }

    async resetAll() {
        this.hotelService.resetAllExtrasHome();
    }

    initFilter(): void {
        this.filtersStaticData = new ObjFilter(this.realparams, 1000, this.partner().agenturen).initExtraFilters();
        this.getStaticData();
    }

    getStaticData() {
        let target = 'offers';
        // console.log(this.mode)
        switch (this.mode) {
            case 'topregions':
                target = 'regions';
                break;
            case 'hotels':
                target = 'hotels';
                break;

            default:
                target = 'offers';
                break;
        }
        if (JSON.stringify(this.filtersStaticData) !== JSON.stringify(this.tmp_filtersStaticData)) {
            this.tmp_filtersStaticData = JSON.parse(JSON.stringify(this.filtersStaticData));
            if (target === 'offers') {
                this.filtersStaticData.optionLists = 'flightCarrier,hotelChain,roomType,boardType,roomId,arrivalAirport,departureAirport,tourOperator,inclusiveCode,transferType';
            }
            // console.log(this.filtersStaticData)
            this.trafficsService.request(this.filtersStaticData, target).pipe(
                takeUntilDestroyed(this.destroyRef)
            ).subscribe(obj => {
                this.tmp_stat = obj;
                // console.log(obj)
                // let found = false
                // for (let i = 0; i < obj?.inclusiveCodeList?.length; i++) {
                //     if (
                //         obj.inclusiveCodeList[i].code === 'CS' ||
                //         obj.inclusiveCodeList[i].code === 'FS' ||
                //         obj.inclusiveCodeList[i].code === 'CR'
                //     ) {
                //         found = true;
                //         i = obj.inclusiveCodeList.length;
                //     }
                // }
                // this.flexfromtraffics = found ? '0' : '1';
                this.tourOperatorList.set(obj?.tourOperatorList);
                this.loading.set(false);
            });
        }
    }
}
